const input = {
    username: 'Benutzername',
    password: 'Passwort',
    email: 'Email',
    phone_number: 'Telefonnummer',
    student_number: 'Matrikelnummer',
    registration_number: 'Registrierungsnummer',
    student_identifier_legend: 'Anmelden mit',
    confirm_password: 'Passwort bestätigen',
    search_region_code: 'Suche region code',
    backup_code: 'Backup-Code',
    code: 'Code',
    label_with_optional: '{{label}} (Optional)',
};
export default Object.freeze(input);
